import React from 'react';
import PropTypes from 'prop-types';

import flow from 'lodash/flow';
import get from 'lodash/get';

import {
  Button,
  FormLayout,
  Heading,
  HorizontalRule,
  IconStatusConfirmationOnlight,
  LogoHsbcGlobal,
  Paragraph,
  Section,
  Panel,
  PlaybackList,
  PlaybackKey,
  PlaybackValue,
  withTrackPage,
} from '@piggybank/core';

import {
  Form,
} from '@piggybank/form';

import { withAppContext } from '~/AppContext';

import styles from './card-success.module.css';

import { formatAmountFromPath } from '~/utils';
import { isButtonVisible, isHeaderVisible } from './cardSuccessFunctions';

import nls from './nls/CardSuccess';
import { createTranslator } from '~/lib/nls-helper';

import getEnvironment from '~/lib/environment';

const environment = getEnvironment();

import format from 'date-fns/format';

const NLS = createTranslator(nls);

const CardSuccess = ({ data }) => {
  const currDateTime = new Date(Date.now());
  const heading = get(data.initialData.offer, 'creditCardOffer.heading');
  return (
    <FormLayout>
      <Section>
        {isHeaderVisible(data.initialData.globalData.ismobile) &&
          <div className={styles.container}>
            <LogoHsbcGlobal />
          </div>
        }
        <div className={styles.confirmation}>
          <IconStatusConfirmationOnlight scaled />
        </div>
        <Heading level={1}>{NLS`Your request was successfully registered`}</Heading>
        <HorizontalRule />
      </Section>
      <Section>
        <Panel>
          <Paragraph lead>{`${NLS`Proof of contracting the`} ${heading}`}</Paragraph>
          <PlaybackList type="strong">
            <PlaybackKey>{NLS`Authorized Credit Limit`}</PlaybackKey>
            <PlaybackValue>{formatAmountFromPath(data.submittedData.creditLimit, 'amount')}</PlaybackValue>
            <PlaybackKey>{NLS`Folio`}</PlaybackKey>
            <PlaybackValue>{data.submittedData.folio}</PlaybackValue>
            <PlaybackKey>{NLS`Date`}</PlaybackKey>
            <PlaybackValue>{format(currDateTime, 'DD/MM/YYYY')}</PlaybackValue>
            <PlaybackKey>{NLS`Time`}</PlaybackKey>
            <PlaybackValue>{format(currDateTime, 'HH:mm:ss')}</PlaybackValue>
            <PlaybackKey>{NLS`Cardholder Management without VAT`}</PlaybackKey>
            <PlaybackValue marginBottom={0}>{get(data.initialData.offer, 'creditCardOffer.annuity')}</PlaybackValue>
          </PlaybackList>
        </Panel>
      </Section>
      <Section>
        <Paragraph>{NLS`In case you see this offer again at HSBC ATMs or receive the offer via telephone, it is not necessary to accept it again because the card is already on its way.`}</Paragraph>
        {isButtonVisible(data.initialData.globalData.ismobile) &&
        <>
          <HorizontalRule hiddenOnSmallViewport />
          <Form children={<Button elementType="a" href={environment.bankingDashboardUrl} target="_self">{NLS`Finish`}</Button>} initialValues={{}} />
        </>
        }
      </Section>
    </FormLayout>
  );
};

CardSuccess.propTypes = {
  data: PropTypes.shape({
    initialData: PropTypes.shape({
      globalData: PropTypes.shape({
        ismobile: PropTypes.string,
        offerId: PropTypes.string,
      }),
      offer: PropTypes.object,
    }),
    submittedData: PropTypes.shape({
      creditLimit: PropTypes.object,
      folio: PropTypes.folio,
    }),
  }),
};

export default flow(
  withAppContext(),
  withTrackPage('cardSuccess', 'component')
)(CardSuccess);

